import {
  CART_REVAMP_TRACKER_TYPE,
  CART_TRACKER_TYPE_FOR_V1_AND_V2,
} from '../../../../shop/constants/tracker';
import { onTrackUpdateItem } from './onTrackUpdateItem';
import { onTrackRemoveItem } from './onTrackRemoveItem';
import { onTrackCartPageLoad } from './onTrackCartPageLoad';
import { onTrackGoCheckout } from './onTrackGoCheckout';
import { onTrackAddAddOnItem } from './onTrackAddAddOnItem';
import { onTrackCouponCenterLinkClick } from './onTrackCouponCenterLinkClick';
import { onTrackPaymentPromoOptionClick } from './onTrackPaymentPromoOptionClick';
import { onTrackPaymentPromoOptionShow } from './onTrackPaymentPromoOptionShow';
import { onTrackPromotionReminderClick } from './onTrackPromotionReminderClick';
import { onTrackPromotionReminderShow } from './onTrackPromotionReminderShow';
import { onTrackAddonAllListClick } from './onTrackAddonAllListClick';
import { onTrackAddonAllListShow } from './onTrackAddonAllListShow';
import { onTrackDeliveryOptionClick } from './onTrackDeliveryOptionClick';
import { onTrackPaymentOptionClick } from './onTrackPaymentOptionClick';
import { onTrackCartMemberLoginClick } from './onTrackCartMemberLoginClick';
import { onTrackCartCodeCreditPointEntranceClick } from './onTrackCartCodeCreditPointEntranceClick';
import { onTrackCartCodeCreditPointApply } from './onTrackCartCodeCreditPointApply';
import { onTrackCartMyCouponApply } from './onTrackCartMyCouponApply';
import { onTrackCartMyCouponSelect } from './onTrackCartMyCouponSelect';
import { onTrackCartRecipientAddressType } from './onTrackCartRecipientAddressType';
import { onTrackViewRelatedProducts } from './onTrackViewRelatedProducts';
import { onTrackProductImpression } from './onTrackProductImpression';
import { onTrackRecommendItem } from './onTrackRecommendItem';
import { onTrackProductClick } from './onTrackProductClick';
import { onTrackRecommendListClick } from './onTrackRecommendListClick';
import { onTrackAddItem } from './onTrackAddItem';

export const onCartTrackEvent = async (trackerType, payload = {}) => {
  switch (trackerType) {
    case CART_REVAMP_TRACKER_TYPE.CartPageLoad:
      onTrackCartPageLoad(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.AddAddOnItem:
      onTrackAddAddOnItem(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.UpdateItem:
      onTrackUpdateItem(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.RemoveItem:
      onTrackRemoveItem(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.GoToCheckout:
      onTrackGoCheckout(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.COUPON_CENTER_LINK_CLICK:
      onTrackCouponCenterLinkClick(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.DELIVERY_OPTION_CLICK:
      onTrackDeliveryOptionClick(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.PAYMENT_OPTION_CLICK:
      onTrackPaymentOptionClick(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_CODE_CREDIT_POINT_ENTRANCE_CLICK:
      onTrackCartCodeCreditPointEntranceClick(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_CODE_CREDIT_POINT_APPLY:
      onTrackCartCodeCreditPointApply(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_MY_COUPON_APPLY:
      onTrackCartMyCouponApply();
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_MY_COUPON_SELECT:
      onTrackCartMyCouponSelect(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.PaymentPromoOptionClick:
      onTrackPaymentPromoOptionClick(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.PaymentPromoOptionShow:
      onTrackPaymentPromoOptionShow(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.PROMOTION_REMINDER_CLICK:
      onTrackPromotionReminderClick(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.PROMOTION_REMINDER_SHOW:
      onTrackPromotionReminderShow(payload);
      break;
    case CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_RECIPIENT_ADDRESS_TYPE:
      onTrackCartRecipientAddressType(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.AddonAllListClick:
      onTrackAddonAllListClick(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.AddonAllListShow:
      onTrackAddonAllListShow(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.CartMemberLoginClick:
      onTrackCartMemberLoginClick(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.ViewRelatedProducts:
      onTrackViewRelatedProducts(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.ProductImpression:
      onTrackProductImpression(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.RecommendItem:
      onTrackRecommendItem(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.ProductClick:
      onTrackProductClick(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.RecommendListClick:
      onTrackRecommendListClick(payload);
      break;
    case CART_REVAMP_TRACKER_TYPE.AddItem:
      onTrackAddItem(payload);
      break;
    default:
      console.error('Invalid tracker type', trackerType);
  }
};
